import React from 'react';

export default function EmptyState({ openModal }) {
  return (
    <div className="p-6 text-center">
      <div className="text-gray-700 mb-4">No attributes found.</div>
      <button onClick={openModal} className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white rounded">Add attribute</button>
    </div>
  );
}
